module.exports = __webpack_public_path__ + "img/ic_back.ab5de8b2.svg";